/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from 'react';
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import TkProcessTempleteSelectList from './../input/TkProcessTempleteSelectList';
import { debounce } from 'lodash';

function TkProcessSelection ( props ) {

    const { templeteLoadData, setInteraction, createdTempleteId, templetes, onInitialized, orderBuyerDetailByProcessGrid } = props;
    
    const [ grid, setGrid] = useState();
    const [ api, setApi ] = useState();

    const [templeteObj, setTempleteObj] = useState({templeteId : "", refresh : false});
    const [selectedProcessList, setSelectedProcessList] = useState([]);


    useEffect(()=>{

        if(templeteObj.refresh ) {

            if(api) {
                api.refresh();
            }
        }

    },[templeteObj]);


    useEffect(() => {

        let firstMountEvent = false;

        if (grid) {

            firstMountEvent = true;

                grid.loadedRows.addHandler(debounce((grid, event) => {

                if(firstMountEvent) {

                    if(orderBuyerDetailByProcessGrid) {
                        let selectedProcessList = [];
                        
                        for(let row of orderBuyerDetailByProcessGrid.rows) {
            
                            selectedProcessList.push(row.dataItem.processCode);
            
                        };
        
                        for(let row of grid.rows) {
        
                            for(const selectedProcess of selectedProcessList) {

                                if(row.dataItem.processCode === selectedProcess) {

                                    row.dataItem.processSelectionCheck = true;
                                    
                                    break;
                                };
         
                            };
        
                        }
                        setSelectedProcessList(selectedProcessList);
            
                    }
                }

                firstMountEvent = false;

            },10))

        }

        }, [grid])

    useEffect(()=>{

        onSearchProcessByTemplete();

    },[selectedProcessList])

    const onGridInitialized = ( grid ) => {

        grid.selectionMode = "None";
        grid.allowSorting = "None";
        
        if(onInitialized) {

            onInitialized(grid);
        }

        setGrid(grid);

    };

    const onApiInitialized = ( api ) => {

        setApi ( api );

    };

    const onSelectTempleteChange = (value) => {

        setTempleteObj({
            templeteId : value,
            refresh : true
        });
    };

    const onSearchProcessByTemplete = () =>{

        let templeteId = "";

        for(const templete of templetes) {
            
            if(templete.processCodeList.length === selectedProcessList.length) {

                let isTrue = templete.processCodeList.every((processCode)=> selectedProcessList.includes(processCode));
                
                if( isTrue ) {

                    templeteId = templete.templeteId;

                    break;
                }
            }
        }
        
        setTempleteObj( {
            templeteId : templeteId, 
            refresh : false 
        });  

    }

    const onModifyViewSchema = (schema) => {

        if (schema) {

            for (const column of schema.columns) {
                
                switch (column.name) {

                    case "processSelectionCheck":

                        column.onChange = (ctx, check) => {

                            setGrid((grid) => {

                                if (grid) {

                                    ctx.item.processSelectionCheck = check;

                                    grid.refresh(false);
                                    setInteraction(true);

                                    let selectedProcessList = [];

                                    for(const row of grid.rows) {

                                        if(row.dataItem.processSelectionCheck) {

                                            selectedProcessList.push(row.dataItem.processCode);
                                        }
                                    }

                                    setSelectedProcessList(selectedProcessList);
                                }

                                return grid;
                            })
                        };
                        break;
                    default:
                        break;

                }
            }
        }
    };

    const onModifyUrl = ( templeteId, url ) => {

        let newUrl;

        if ( templeteId ) {

            newUrl = url + "/" + templeteId;

        } else {

            newUrl = url + "/undefined";

        }

        return newUrl;
        
    };

    const onLoadData = (data) => {

        if(templeteLoadData) {

            templeteLoadData(data);
        }

    }


    return (
            <BasicCrudScreenType
                id="TkVwProcessSelection"
                view="TkVwProcessSelection"
                noCreate
                noEdit
                noDelete
                noExcel
                noFilter
                noSearch
                noPagination
                onApiInitialized={onApiInitialized}
                onInitialized={onGridInitialized}
                onModifyViewSchema={onModifyViewSchema}
                onModifyViewUrl={( url ) => onModifyUrl ( templeteObj.templeteId, url )}
                onLoadData = {onLoadData}
                onAppendButtonInFrontOfSearch={
                    () => (
                        <BasicCrudScreenActionItemLayout>
                            <TkProcessTempleteSelectList
                                createdTempleteId= {createdTempleteId}
                                checkProcessSameTempleteId = {templeteObj.templeteId}
                                onSelectTempleteChange = {onSelectTempleteChange}
                            />
                            
                        </BasicCrudScreenActionItemLayout>
                    )
                }
            />
    );
}

export default TkProcessSelection;
